<template>
  <v-dialog v-model="dialog" width="1200px" height="800px" style="max-height: 800px !important" persistent
    @keydown.esc="chiudiDialog()">
    <v-card style="height: 800px !important; background-color: #fff">
      <v-toolbar color="#EE1453" dark height="48">
        <v-btn icon dark v-on:click="chiudiDialog()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title style="font-size: 105%;">
          <v-row no-gutters> Dettaglio ex clienti {{ filtro }} </v-row>
          <v-row no-gutters> Numero clienti: {{ numeroExClienti }} </v-row>
        </v-toolbar-title>

        <v-btn icon @click="esportaPdf()">
          <v-icon>picture_as_pdf</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn icon dark v-on:click="caricaDati()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-text-field class="ml-4 mr-4" label="Cerca" v-model="search" style="width: 50%" clearable></v-text-field>

      <v-container class="pa-0" style="background-color: #fff">
        <v-container style="font-size: 1.1em">
          <v-col>
            <v-data-table v-if="role == 'Admin' || role == 'AgenteCapo'" dense :headers="headersTabella"
              mobile-breakpoint="0" :items="elencoClienti" :items-per-page="pag" no-data-text="Nessun dato disponibile"
              hide-default-footer :search="search" :no-results-text="'Nessun dato trovato'" item-key="AnNomAge"
              slot="extension" @click:row="rowClicked" :expanded.sync="expanded" :single-expand="true">

              <template v-slot:item="{ item, expand, isExpanded }">
                <tr v-on:click.prevent="caricaDettaglio(item); rowClicked(item);">
                  <td>{{ item.AnNomAge }}</td>
                  <td>{{ item.NumClienti }}</td>
                  <td>
                    <v-btn icon>
                      <v-icon> expand_more </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="{ headers, item }"><!--  v-if="item.id == selectedRow.id" -->
                <td :colspan="headers.length" style="padding: 0px;">
                  <v-card class="ml-4 mr-4">
                    <v-col>
                      <v-data-table :headers="headersTabellaDett" :items="elencoClientiDett" item-key="ClRagSoc"
                        mobile-breakpoint="0" hide-default-footer :items-per-page="itemsPerPage">
                        <template v-slot:item="{ item }">
                          <tr>
                            <td>{{ item.AnNomAge }}</td>
                            <td>
                              {{ $i2kFunctions.formatISODate(item.Data_Ord) }}
                            </td>
                            <td>{{ item.ClRagSoc }}</td>
                            <td>{{ item.ClLocali }}</td>
                            <td>{{ item.ClProvin }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-card>
                </td>
              </template>
            </v-data-table>

            <v-data-table v-else dense :headers="headersTabellaDett" :items="elencoClienti" mobile-breakpoint="0"
              :items-per-page="itemsPerPage" no-data-text="Nessun dato disponibile" hide-default-footer :search="search"
              :no-results-text="'Nessun dato trovato'" item-key="ClRagSoc">
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.AnNomAge }}</td>
                  <td>
                    {{ $i2kFunctions.formatISODate(item.Data_Ord) }}
                  </td>
                  <td>{{ item.ClRagSoc }}</td>
                  <td>{{ item.ClLocali }}</td>
                  <td>{{ item.ClProvin }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-container>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  get_dettaglioExClienti,
  get_pdfExClienti,
} from "@/api/api.statistiche.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
    filtro: { type: String, default: "" },
    numeroExClienti: { type: Number, default: 0 },
  },
  data: () => ({
    headersTabellaDett: [
      { text: "Agente", value: "AnNomAge" },
      { text: "Data ultimo ordine", value: "Data_Ord" },
      { text: "Ragione sociale", value: "ClRagSoc" },
      { text: "Località", value: "ClLocali" },
      { text: "Provincia", value: "ClProvin" },
    ],

    headersTabella: [
      { text: "Agente", value: "AnNomAge" },
      { text: "Clienti persi", value: "NumClienti" },
      { text: "", value: "espandi" },
    ],
    elencoClienti: [],
    elencoClientiDett: [],
    pag: 20,
    itemsPerPage: 999,
    search: "",

    expanded: [],
    singleExpand: false,
    rowClickedData: [],
    selectedRow: {},
  }),

  methods: {
    async caricaDati() {
      if (this.role != "Admin") return;
      this.elencoClienti = [];
      let par = "";
      if (this.userSwitch.Codice != undefined)
        par = "?idAgente=" + this.userSwitch.Codice;
      else if (this.codice) par = "?idAgente=" + this.codice;
      else if (this.role == "Admin") par = "?idAgente=0";
      if (this.codice == 0) par = "";
      let data = {
        dataDa1: this.filtro.length == 4 ? this.filtro + "-01-01" : this.filtro,
      };
      let res = await get_dettaglioExClienti(par, data);
      this.elencoClienti = res.data;
      let id = 0;
      this.elencoClienti.forEach((el) => {
        el.id = id;
        id += 1;
      });
    },

    chiudiDialog() {
      this.$emit("chiudiDialog");
    },

    async caricaDettaglio(props) {
      this.selectedRow = props;
      /* props.expanded = !props.expanded;
      this.selectedRow = props.item;
      if (!props.expanded) {
        this.selectedRow = {};
        return;
      }

      let par = "?idAgente=" + props.AnCodAge;
      let data = {
        dataDa1: this.filtro.length == 4 ? this.filtro + "-01-01" : this.filtro,
      };
      let res = await get_dettaglioExClienti(par, data);
      this.elencoClientiDett = res.data; */
    },

    async rowClicked(props) {
      this.rowClickedData = props;
      this.expanded = [];
      props.expanded = !props.expanded;
      if (!props.expanded) {
        this.ResetExpanded();
        return;
      }
      this.expanded.push(props);
      let par = "?idAgente=" + props.AnCodAge;
      let data = {
        dataDa1: this.filtro.length == 4 ? this.filtro + "-01-01" : this.filtro,
      };
      let res = await get_dettaglioExClienti(par, data);
      this.elencoClientiDett = res.data;
    },

    ResetExpanded() {
      this.elencoClienti.forEach((el) => {
        el.expanded = false;
      });
    },

    async esportaPdf() {
      let par = "";
      if (this.userSwitch.Codice != undefined)
        par = "?idAgente=" + this.userSwitch.Codice;
      else if (this.codice) par = "?idAgente=" + this.codice;
      else if (this.role == "Admin") par = "?idAgente=0";

      let data = {
        dataDa1: this.filtro.length == 4 ? this.filtro + "-01-01" : this.filtro,
      };
      let res = await get_pdfExClienti(par, data);
      this.$i2kFunctions.createBlobPdf(res.data);
    },
  },

  watch: {
    dialog() {
      if (this.dialog) this.caricaDati();
    },
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    role: function () {
      return this.$store.getters["user/getRole"];
    },

    codice: function () {
      return this.$store.getters["user/getCodice"];
    },
  },
};
</script>